export const filterById = (items: any[], id: string) =>
  (items && items.filter((el: { id: string }) => el.id === id)) || [];
